<template>
  <section>
    <v-dialog
      v-model="modalAction"
      max-width="600px"
      scrollable
      @keydown="executeCloseModalFilterFolders"
      @click:outside="executeCloseModalFilterFolders"
    >
      <v-card>
        <div class="p-4 pb-0">
          <h5>Filtros de Carpetas y Subcarpetas</h5>
        </div>
        <hr />
        <v-card-text>
          <v-row class="px-4">
            <v-col cols="12" lg="12" md="12" sm="12" class="mb-2">
              <v-text-field
                label="Búsqueda"
                v-model="filters.filter"
                clearable
                class="mt-3"
                placeholder="Búsqueda"
                append-icon="mdi-magnify"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              lg="12"
              md="12"
              sm="12"
              class="mb-2"
              v-if="businessUnits.length > 1 && !isProject && !isPresale"
            >
              <v-autocomplete
                class="mt-3"
                placeholder="Filtrar por Unidad de Negocio"
                v-model="filters.business_unit"
                :items="activeBusinessUnits"
                item-text="name"
                item-value="name"
                clearable
              ></v-autocomplete>
            </v-col>
            <!-- <v-col cols="12" lg="12" md="12" sm="12" class="mb-2">
              <v-autocomplete
                v-model="filters.items"
                class="mt-3"
                :items="[5, 10, 15, 20, 25, 100]"
                label="Items por Página"
              >
              </v-autocomplete>
            </v-col> -->
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined @click="emitClearAllFilters">
            <small> Limpiar Filtros </small>
          </v-btn>
          <v-btn
            color="red darken-1"
            outlined
            @click="executeCloseModalFilterFolders"
          >
            <small> Cerrar </small>
          </v-btn>
          <v-btn color="primary" @click="searchFilters">
            <small> Buscar </small>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";
import { ACTIVE_BUSINESS_UNITS } from "@/constants/common";

export default {
  props: {
    modalAction: {
      type: Boolean,
      default: false,
    },
    closeModalFilterFolders: {
      type: Function,
      default: () => {},
    },
    isPresale: {
      type: Boolean,
      default: false,
    },
    isProject: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filters: {
        filter: null,
        business_unit: null,
        items: 10,
      },
    };
  },
  methods: {
    executeCloseModalFilterFolders($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.closeModalFilterFolders($event);
      }
    },
    emitClearAllFilters() {
      this.filters.filter = null;
      this.filters.business_unit = null;
      this.filters.items = 10;
      this.$emit("clearAllFilters");
    },
    searchFilters() {
      this.$emit("searchFilters", {
        filter: this.filters.filter,
        business_unit: this.filters.business_unit,
        items: this.filters.items,
      });
      this.closeModalFilterFolders(true);
    },
  },
  computed: {
    ...mapGetters({
      documentsTypes: "document/documentsTypes",
      businessUnits: "document/businessUnits",
    }),
    activeBusinessUnits() {
      return this.businessUnits.filter((item) =>
        ACTIVE_BUSINESS_UNITS.includes(item.name)
      );
    },
  },
};
</script>

<style></style>
